import React from 'react';
import { Icon, IconButton } from 'fronton-react';
import { StoreStockData } from './types';
import { questionIconStyle } from './styles';
import { useTranslation } from 'react-i18next';
import { QuestionIcon } from '@fronton/icons-react';

export type TitleNonInteractiveProps = {
  availableStore: StoreStockData | null;
  regionCode: string;
  stocks: StoreStockData[];
};

type QuestionIconButtonProps = {
  onMouseEnter: () => void;
  onMouseLeave: () => void;
};

export const QuestionIconButton = React.forwardRef<HTMLButtonElement, QuestionIconButtonProps>(
  (props, ref) => {
    const { t } = useTranslation();

    return (
      <IconButton
        ref={ref}
        onMouseEnter={props.onMouseEnter}
        onMouseLeave={props.onMouseLeave}
        className={questionIconStyle}
        aria-label={t('product-info.stocks.in-stores.aria-label-tooltip')}
      >
        <Icon color="secondary-blue-primary" size="l">
          <QuestionIcon />
        </Icon>
      </IconButton>
    );
  },
);
